export const SET_OPTION = 'SET_OPTION';
export const SET_SCHEDULED_PAYMENTS = 'SET_SCHEDULED_PAYMENTS';
export const FETCH_SCHEDULED_PAYMENTS = 'FETCH_SCHEDULED_PAYMENTS';